import { render, staticRenderFns } from "./TwoStepVerificationActivateForm.vue?vue&type=template&id=3951f133"
import script from "./TwoStepVerificationActivateForm.vue?vue&type=script&lang=js"
export * from "./TwoStepVerificationActivateForm.vue?vue&type=script&lang=js"
import style0 from "./TwoStepVerificationActivateForm.vue?vue&type=style&index=0&id=3951f133&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports